/* Lavender Farm Simulator — speed & safety recorder (rebuild step 1).
   Only runs for the admin QA session (or when localStorage.gllfPerfOn = "1"); players get nothing extra.
   Records, in this browser only (localStorage "gllfPerfLogV1", last 300 entries):
     • script errors from the simulator's files
     • how long each tab switch takes to show, and how long the page froze in the 1.5 s after
     • how long "Advance week" takes and how long the page froze
     • how busy the page is while nobody is doing anything (5 s sample each minute)
     • every call to the simulator server (/apps/simulator/v1 — cloud save, snapshots, profile, leaderboard)
       and the Prayer Field server: when, what, status and time taken
   Console: GLLFPerf.report() prints a summary; GLLFPerf.clear() empties the log. Never touches the save. */
(function () {
  'use strict';
  if (window.GLLFPerf) return;
  var on = false;
  try { on = !!sessionStorage.getItem('gllfAdminModeV65') || localStorage.getItem('gllfPerfOn') === '1'; } catch (e) {}
  if (!on) { window.GLLFPerf = { off: true }; return; }

  var KEY = 'gllfPerfLogV1', log = [];
  try { log = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { log = []; }
  var dirty = false;
  function add(kind, data) {
    data = data || {}; data.k = kind; data.t = Date.now();
    log.push(data); if (log.length > 300) log = log.slice(-300); dirty = true;
  }
  setInterval(function () { if (!dirty) return; dirty = false; try { localStorage.setItem(KEY, JSON.stringify(log)); } catch (e) {} }, 5000);
  addEventListener('pagehide', function () { try { localStorage.setItem(KEY, JSON.stringify(log)); } catch (e) {} });

  /* long frames (the browser's own measurement of freezes) */
  var busy = 0, frames = 0, worst = 0;
  try {
    new PerformanceObserver(function (l) { l.getEntries().forEach(function (e) { busy += e.duration; frames++; if (e.duration > worst) worst = e.duration; }); })
      .observe({ type: 'long-animation-frame', buffered: false });
  } catch (e) {
    try { new PerformanceObserver(function (l) { l.getEntries().forEach(function (e) { busy += e.duration; frames++; if (e.duration > worst) worst = e.duration; }); }).observe({ type: 'longtask' }); } catch (x) {}
  }
  function mark() { return { b: busy, f: frames, w: worst }; }
  function since(m) { return { busy: Math.round(busy - m.b), frames: frames - m.f }; }
  function shown(cb, startMark, t0, win) {
    /* "shown" = two painted frames after the change; "busy" = long-frame time in the next win ms */
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      var ms = Math.round(performance.now() - t0);
      setTimeout(function () { cb(ms, since(startMark)); }, Math.max(0, win - ms));
    }); });
  }

  /* errors */
  function isOurs(src) { return /gllf|lfg|simulator/i.test(String(src || '')); }
  addEventListener('error', function (e) { if (isOurs(e.filename)) add('error', { msg: String(e.message).slice(0, 200), file: String(e.filename || '').split('/').pop().split('?')[0], line: e.lineno }); }, true);
  addEventListener('unhandledrejection', function (e) { var r = e.reason, s = r && r.stack; if (isOurs(s)) add('error', { msg: String((r && r.message) || r).slice(0, 200), file: 'promise' }); });

  /* tab switches */
  var tabStart = null;
  document.addEventListener('lfg:route-leave', function (e) { tabStart = { t0: performance.now(), m: mark(), from: e.detail && e.detail.route, to: e.detail && e.detail.next }; }, true);
  document.addEventListener('lfg:route-enter', function (e) {
    var s = tabStart; tabStart = null; if (!s) return;
    shown(function (ms, b) { add('tab', { from: s.from, to: (e.detail && e.detail.route) || s.to, ms: ms, busy: b.busy }); }, s.m, s.t0, 1500);
  }, true);

  /* advance week */
  function root() { return document.getElementById('lfg-simulator-root'); }
  function week() { try { var s = root()._lfg.state(); return s.year + '/' + s.season + '/' + s.week; } catch (e) { return ''; } }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-action="advance"],[data-time-advance-week]'); if (!b) return;
    var w0 = week(), t0 = performance.now(), m = mark(), n = 0;
    (function wait() {
      if (week() !== w0) return shown(function (ms, x) { add('advance', { ms: ms, busy: x.busy, frames: x.frames, week: week() }); }, m, t0, 3000);
      if (++n < 150) setTimeout(wait, 100); else add('advance', { ms: -1, note: 'week did not change in 15 s', busy: since(m).busy });
    })();
  }, true);

  /* idle sample: 5 s each minute while visible and nobody pressed anything recently */
  var lastInput = 0;
  ['pointerdown', 'keydown', 'wheel'].forEach(function (ev) { addEventListener(ev, function () { lastInput = Date.now(); }, true); });
  setInterval(function () {
    if (document.hidden || Date.now() - lastInput < 10000) return;
    var m = mark(), view = (root() && root().querySelector('section.lfg-view.active') || {}).id || '';
    setTimeout(function () { if (Date.now() - lastInput < 5000) return; var x = since(m); add('idle', { view: view.replace('lfg-view-', ''), busy: x.busy, frames: x.frames, els: root() ? root().getElementsByTagName('*').length : 0 }); }, 5000);
  }, 60000);

  /* server calls */
  function watched(u) { return /\/apps\/simulator\/v1|prayer/i.test(String(u || '')); }
  function what(u) { var p = String(u).split('?')[0]; var m = /\/apps\/simulator\/v1\/?([^\/]*)/.exec(p); return m ? (m[1] || 'root') : p.split('/').slice(-2).join('/'); }
  var nf = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!watched(url)) return nf.apply(this, arguments);
    var t0 = performance.now(), method = (init && init.method) || (input && input.method) || 'GET';
    return nf.apply(this, arguments).then(function (res) {
      add('server', { what: what(url), method: method, status: res.status, ms: Math.round(performance.now() - t0) }); return res;
    }, function (err) { add('server', { what: what(url), method: method, status: 'failed', ms: Math.round(performance.now() - t0) }); throw err; });
  };
  if (navigator.sendBeacon) {
    var sb = navigator.sendBeacon.bind(navigator);
    navigator.sendBeacon = function (url, data) { var ok = sb(url, data); if (watched(url)) add('server', { what: what(url), method: 'BEACON', status: ok ? 'queued' : 'refused', ms: 0 }); return ok; };
  }

  function summary() {
    function pick(k) { return log.filter(function (x) { return x.k === k; }); }
    function avg(a, f) { return a.length ? Math.round(a.reduce(function (s, x) { return s + (+x[f] || 0); }, 0) / a.length) : '-'; }
    var tabs = pick('tab'), adv = pick('advance').filter(function (x) { return x.ms >= 0; }), idle = pick('idle'), srv = pick('server'), err = pick('error');
    var byWhat = {}; srv.forEach(function (x) { var k = x.method + ' ' + x.what; var e = byWhat[k] = byWhat[k] || { n: 0, bad: 0, ms: 0 }; e.n++; e.ms += x.ms; if (!(x.status >= 200 && x.status < 400) && x.status !== 'queued') e.bad++; });
    return [
      'Tab switches: ' + tabs.length + ', average ' + avg(tabs, 'ms') + ' ms to show, ' + avg(tabs, 'busy') + ' ms frozen in the next 1.5 s',
      'Advance week: ' + adv.length + ', average ' + avg(adv, 'ms') + ' ms to show, ' + avg(adv, 'busy') + ' ms frozen in 3 s' + (pick('advance').length > adv.length ? ' (' + (pick('advance').length - adv.length) + ' did not advance)' : ''),
      'Idle samples: ' + idle.length + ', average ' + avg(idle, 'busy') + ' ms busy per 5 s, ~' + avg(idle, 'els') + ' elements',
      'Server calls: ' + Object.keys(byWhat).map(function (k) { var e = byWhat[k]; return k + ' ×' + e.n + (e.bad ? ' (' + e.bad + ' failed)' : '') + ' avg ' + Math.round(e.ms / e.n) + ' ms'; }).join(' · '),
      'Errors: ' + err.length + (err.length ? ' — last: ' + err[err.length - 1].msg + ' (' + err[err.length - 1].file + ')' : '')
    ].join('\n');
  }
  window.GLLFPerf = { log: function () { return log.slice(); }, report: function () { var s = summary(); try { console.log(s); } catch (e) {} return s; }, clear: function () { log = []; dirty = true; } };
})();
